import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'duplicate',
  props: {
  color: {
    type: String,
    default: '#000000'
  },
  width: {
    type: String,
    default: '24'
  },
  height: {
    type: String,
    default: '24'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      fill: __props.color,
      d: "M472,16H160a24.027,24.027,0,0,0-24,24V352a24.027,24.027,0,0,0,24,24H472a24.027,24.027,0,0,0,24-24V40A24.027,24.027,0,0,0,472,16Zm-8,328H168V48H464Z"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      fill: __props.color,
      d: "M344,464H48V168h56V136H40a24.027,24.027,0,0,0-24,24V472a24.027,24.027,0,0,0,24,24H352a24.027,24.027,0,0,0,24-24V408H344Z"
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})